import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "./Icon";
import PageFrame, { LoadFailed, Loading } from "./PageFrame";
import ProjectView from "./ProjectView";
import useCoursePlans from "./useCoursePlans";

const intro = "One project in the final weeks, built as a team. Passing it is one of your certificate requirements.";

/** Prototype empty state: what happens before the instructor releases the brief. */
function NotSetUp({ course, onCourse }) {
  return (
    <section className="empty">
      <div className="empty-ico"><Icon name="folder" size={30} /></div>
      <h3>Your capstone project isn't set up yet</h3>
      <p>Your instructor releases the brief and puts everyone into teams before the final week. You'll get an email and a notification when it's ready.</p>
      <ol className="empty-steps">
        <li><b>1</b><div><strong>Get your team and brief</strong><small>Before the final week · your team rep is named here</small></div></li>
        <li><b>2</b><div><strong>Build it together</strong><small>Final week · your team rep submits for the team</small></div></li>
        <li><b>3</b><div><strong>Present at the showcase</strong><small>One of your certificate requirements</small></div></li>
      </ol>
      {course && <button className="cbtn quiet" type="button" onClick={onCourse}>Back to my course</button>}
    </section>
  );
}

/** Capstone projects across the student's courses (prototype projectsPage). */
export default function ProjectsPage() {
  const navigate = useNavigate();
  const { plans, failed, reload } = useCoursePlans();
  const [picked, setPicked] = useState(null);

  if (failed) return <PageFrame title="Capstone project" intro={intro}><LoadFailed what="projects" onRetry={reload} /></PageFrame>;
  if (!plans) return <PageFrame title="Capstone project" intro={intro}><Loading /></PageFrame>;
  if (!plans.length) return <PageFrame title="Capstone project" intro={intro}><NotSetUp /></PageFrame>;

  // Start on a course that has a project, preferring active ones (plans are sorted active first).
  const key = (c) => `${c.course.uuid}:${c.cohort.id}`;
  const current = plans.find((c) => key(c) === picked) || plans.find((c) => c.plan.weeks.some((w) => w.projects.length)) || plans[0];
  const projects = current.plan.weeks.flatMap((w) => w.projects.map((p) => ({ ...p, weekLabel: w.label })));

  return (
    <PageFrame title={projects.length > 1 ? "Projects" : "Capstone project"} intro={projects.length > 1 ? "Your course projects, the capstone included. Submit each one here and see its grade and feedback." : intro}>
      {plans.length > 1 && (
        <div className="lb-tabs chips-row" role="group" aria-label="Course">
          {plans.map((c) => (
            <button key={key(c)} type="button" aria-pressed={c === current} onClick={() => setPicked(key(c))}>{c.course.title}{plans.filter((x) => x.course.uuid === c.course.uuid).length > 1 ? ` · ${c.cohort.name}` : ""}</button>
          ))}
        </div>
      )}
      {projects.length
        ? projects.map((p) => projects.length > 1
          ? <section key={p.id} className="proj-block"><ProjectView project={p} course={current.course.title} heading={false} onChanged={reload} /></section>
          : <ProjectView key={p.id} project={p} course={current.course.title} heading={false} onChanged={reload} />)
        : <NotSetUp course={current.course} onCourse={() => navigate(`/dashboard/course/${current.course.uuid}?cohort_id=${current.cohort.id}`)} />}
    </PageFrame>
  );
}
